
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M11.91 50.75v7.66M51.75 38.04V24.1H59v13.94M1 38.04V24.1h7.25v13.94M48.16 50.75v7.66"}}),_c('path',{attrs:{"d":"M55.41 24.12v-7.71a6.83 6.83 0 00-6.79-6.82H11.45a6.83 6.83 0 00-6.79 6.82v7.71M30.03 10.05v40.47M1 38.04h58v12.48H1z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    